/* eslint-disable */
/* eslint-disable react/prop-types */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import React, { useEffect, useRef } from "react";
import { RichTextEditor } from "@mantine/tiptap";
import { useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import LinkExtension from "@tiptap/extension-link";
import ImageExtension from "@tiptap/extension-image";
import { Photo } from "tabler-icons-react";

interface RichTextEditorProps {
  value: string;
  onChange: (html: string) => void;
}

export function RichTiptapEditor({ value, onChange }: RichTextEditorProps) {
  const blobUrlsRef = useRef<string[]>([]);

  const editor = useEditor({
    extensions: [
      StarterKit,
      LinkExtension.configure({ openOnClick: false }),
      ImageExtension,
    ],
    content: value,
    onUpdate: ({ editor: tiptapEditor }) => onChange(tiptapEditor.getHTML()),
  });

  const convertBase64ImagesToObjectURLs = (html: string) => {
    if (blobUrlsRef.current.length) {
      blobUrlsRef.current.forEach((u) => {
        try {
          URL.revokeObjectURL(u);
        } catch (err) {}
      });
      blobUrlsRef.current = [];
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(html || "", "text/html");
    const imgs = Array.from(doc.querySelectorAll("img"));

    imgs.forEach((img) => {
      const src = img.getAttribute("src") || "";
      if (src.startsWith("data:")) {
        try {
          const parts = src.split(",");
          if (parts.length < 2) return;
          const meta = parts[0];
          const base64 = parts.slice(1).join(",");

          const mime = (meta.split(":")[1] || "image/png").split(";")[0];

          const binary = atob(base64);
          const len = binary.length;
          const buffer = new Uint8Array(len);
          for (let i = 0; i < len; i++) buffer[i] = binary.charCodeAt(i);

          const blob = new Blob([buffer], { type: mime });
          const url = URL.createObjectURL(blob);
          blobUrlsRef.current.push(url);

          img.setAttribute("src", url);
        } catch (err) {
          console.log(err);
        }
      }
    });

    return doc.body.innerHTML;
  };

  useEffect(() => {
    if (!editor) return;

    const editorHtml = editor.getHTML();
    if (value && value !== editorHtml) {
      const converted = convertBase64ImagesToObjectURLs(value || "");

      editor.commands.setContent(converted, { emitUpdate: false });
    }

    return () => {
      blobUrlsRef.current.forEach((u) => {
        try {
          URL.revokeObjectURL(u);
        } catch (err) {}
      });
      blobUrlsRef.current = [];
    };
  }, [value, editor]);

  const handleImageUpload = (file: File) =>
    new Promise<string>((resolve, reject) => {
      if (file.size > 1024 * 1024) {
        reject(new Error("Image size exceeds 1MB"));
        return;
      }
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = () => reject(new Error("Failed to read file"));
      reader.readAsDataURL(file);
    });

  const onImageChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file || !editor) return;
    try {
      const src = await handleImageUpload(file);
      editor.chain().focus().setImage({ src }).run();
    } catch (err) {
      console.error(err);
    } finally {
      e.target.value = "";
    }
  };

  return (
    <RichTextEditor editor={editor}>
      <RichTextEditor.Toolbar sticky stickyOffset={60}>
        <RichTextEditor.ControlsGroup>
          <RichTextEditor.H1 />
          {/* <RichTextEditor.H2 />
          <RichTextEditor.H3 />
          <RichTextEditor.H4 />
          <RichTextEditor.H5 />
          <RichTextEditor.H6 /> */}
        </RichTextEditor.ControlsGroup>

        <RichTextEditor.ControlsGroup>
          <RichTextEditor.Bold />
          <RichTextEditor.Italic />
          <RichTextEditor.Underline />
          <RichTextEditor.Blockquote />
          <RichTextEditor.CodeBlock />
          <RichTextEditor.Code />
        </RichTextEditor.ControlsGroup>

        <RichTextEditor.ControlsGroup>
          <RichTextEditor.BulletList />
          <RichTextEditor.OrderedList />
          <RichTextEditor.Subscript />
          <RichTextEditor.Superscript />
        </RichTextEditor.ControlsGroup>

        <RichTextEditor.ControlsGroup>
          <RichTextEditor.AlignLeft />
          <RichTextEditor.AlignCenter />
          <RichTextEditor.AlignJustify />
          <RichTextEditor.AlignRight />
        </RichTextEditor.ControlsGroup>

        <RichTextEditor.ControlsGroup>
          {/* <RichTextEditor.Link />
          <RichTextEditor.Unlink /> */}
        </RichTextEditor.ControlsGroup>

        <RichTextEditor.ControlsGroup>
          <label>
            <Photo />
            <input
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={onImageChange}
            />
          </label>
        </RichTextEditor.ControlsGroup>

        {/* <RichTextEditor.ControlsGroup>
          <ActionIcon
            size="lg"
            onClick={() => editor?.chain().focus().undo().run()}
            disabled={!editor?.can().undo()}
            aria-label="Undo"
          />
          <ActionIcon
            size="lg"
            onClick={() => editor?.chain().focus().redo().run()}
            disabled={!editor?.can().redo()}
            aria-label="Redo"
          >
            <IconRotateClockwise size={18} />
          </ActionIcon>
        </RichTextEditor.ControlsGroup> */}
      </RichTextEditor.Toolbar>

      <RichTextEditor.Content
        sx={{
          ".ProseMirror": {
            minHeight: 150,
            maxHeight: 250,
            overflowY: "auto",
            boxSizing: "border-box",
          },
        }}
        onPaste={async (event) => {
          const items = Array.from(event.clipboardData?.files || []);
          if (items.length > 0) {
            event.preventDefault();
            const file = items[0];
            try {
              const src = await handleImageUpload(file);
              editor?.chain().focus().setImage({ src }).run();
            } catch (err) {
              console.error(err);
            }
          }
        }}
      />
    </RichTextEditor>
  );
}
